var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineArabic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 70,
    viewBox: "0 0 590 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.049 16.5623C140.161 42.0288 99.233 71.2514 50.5786 68.9821C34.9753 68.2576 17.7294 64.2979 7.34513 51.6491C-6.3073 35.814 3.74035 12.3161 21.0411 4.2019C23.5123 3.48554 32.2498 -1.98854 33.5842 0.983895C12.0683 8.25946 -0.518288 37.4637 19.723 53.4557C35.4541 66.2033 57.4131 65.3341 76.0908 61.0655C102.865 54.8925 126.426 40.1915 149.2 25.3407C158.479 20.0787 167.016 12.4873 177.614 10.1771C204.055 5.77511 177.944 41.8391 206.054 44.2379C228.564 45.0928 250.54 38.2228 272.396 33.7188C314.852 24.1924 357.463 14.6536 400.784 10.0905C413.821 9.64216 446.711 3.83795 440.997 25.9378C432.205 51.7732 460.031 43.224 475.043 42.5585C501.567 39.6402 528.153 37.2649 554.861 37.212C566.733 37.0285 579.171 36.9919 589.979 42.5229C586.186 44.8431 581.67 41.5824 577.536 41.6333C547.481 38.7148 517.257 43.9117 487.363 46.8129C469.15 48.2874 448.763 54.5663 431.676 45.4811C424.342 41.4969 426.376 32.813 427.411 26.0052C427.962 22.1769 429.715 16.0222 424.119 15.6034C413.817 14.4285 403.371 16.1465 393.097 17.0126C340.427 23.2315 289.158 36.9349 237.235 47.2664C218.34 50.2399 182.77 56.6707 179.46 30.0322C179.264 25.3102 179.346 21.4849 179.049 16.5623Z",
    fill: "#ED6140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineArabic);
export default __webpack_public_path__ + "static/media/underlineArabic.e221111de90ddf317898ba37b25fa66c.svg";
export { ForwardRef as ReactComponent };